// extracted by mini-css-extract-plugin
export default {"container":"i2-z","heading":"j2-z","links":"k2-z","copy":"l2-z","subCopy":"m2-z","linksLeft":"n2-z","linksCenter":"o2-z","linksRight":"p2-z","link":"q2-z","onlyLink":"r2-z"};